import { AppState } from "./app.reducer";

export function getInitialState(): Partial<AppState> {
  const saved = localStorage.getItem('appState');
  return saved ? JSON.parse(atob(saved)) : {};
}